// ----------------------------------------------------------------------

function path(root, sublink) {
  return `${root}${sublink}`;
}

const ROOTS_AUTH = '/auth';
const ROOTS_DASHBOARD = '/dashboard';
const ROOTS_ONBOARDING = '/onboarding';
const ROOTS_MANAGEFENCE = '/fence';

export const PATH_HOME = {
  checkout: '/checkout',
  subscription: '/subscription',
  about: '/aboutus',
  faqs: '/faqs',
  arpage: '/ar',
  edfence: '/edfence',
  blogs: '/blog',
  blogDetail: (id) => `/blog/${id}`,
  contact: '/contactus',
  meeting: '/meeting',
  shopper: '/shopper',
  ourfences: '/ourfences',
  ourfenceDetail: (id) => `/ourfences/${id}`,
  getStarted: '/getStarted',
  download: '/download',
  features: '/features',
  marketplace: '/marketplace',
  marketplaceApply: '/marketplace/apply',
  legal: '/legal',
  privacyPolicy: '/privacy-policy',
  termsAndConditions: '/terms-and-conditions',
  quotePublic: (token) => `/quote/${token}`,
  quotePublicAgreement: (token, step) => `/quote/${token}/agreements/${step}`,
  quotePublicOg: (token) => `/quote/${token}/og.png`,
  materialListPublic: (token) => `/material-list/${token}`,
  materialListPublicOg: (token) => `/material-list/${token}/og.png`,
  virtualEstimatorPublic: (companySlug) => `/virtual-estimator/${companySlug}`,
  virtualEstimatorPublicEstimate: (companySlug, publicAccessToken) =>
    `/virtual-estimator/${companySlug}/estimate/${publicAccessToken}`,
  virtualEstimatorPublicEstimateOg: (companySlug, publicAccessToken) =>
    `/virtual-estimator/${companySlug}/estimate/${publicAccessToken}/og.png`,
  quotesAndMaterials: '/quotes-and-materials',
  start: '/start',
};

// Legacy alias used by older home-layout code paths.
export const PATH_PAGE = {
  payment: PATH_HOME.checkout,
  subscription: PATH_HOME.subscription,
  trialpayment: PATH_HOME.subscription,
};
export const PATH_AUTH = {
  root: ROOTS_AUTH,
  login: path(ROOTS_AUTH, '/login'),
  forgotPassword: path(ROOTS_AUTH, '/forgotPassword'),
  setPassword: path(ROOTS_AUTH, '/setPassword'),
  verify: path(ROOTS_AUTH, '/verify'),
  verifyPhone: path(ROOTS_AUTH, '/verifyPhone'),
  checkEmail: path(ROOTS_AUTH, '/checkEmail'),
  resetPassword: path(ROOTS_AUTH, '/reset-password'),
  newPassword: path(ROOTS_AUTH, '/new-password'),
  resetPasswordVerify: path(ROOTS_AUTH, '/resetPasswordVerify'),
  downloadApp: path(ROOTS_AUTH, '/downloadApp'),
  reactivate: path(ROOTS_AUTH, '/reactivate'),
};
export const PATH_DASHBOARD = {
  // accounts
  account: path(ROOTS_DASHBOARD, '/account'),
  chooseNewPlan: path(ROOTS_DASHBOARD, '/account/choosenewplan'),
  almostDone: path(ROOTS_DASHBOARD, '/account/almostdone'),
  switchBilling: path(ROOTS_DASHBOARD, '/account/switchbilling'),
  updatePaymentMethod: path(ROOTS_DASHBOARD, '/account/updatepaymentmethod'),
  updateAccount: path(ROOTS_DASHBOARD, '/account/updateaccount'),
  updateChildUsers: path(ROOTS_DASHBOARD, '/account/updatechildusers'),
  callForCancel: path(ROOTS_DASHBOARD, '/account/confirmcancelsubscription'),
  // billings
  billing: path(ROOTS_DASHBOARD, '/billing'),
  billingDetail: (id) => path(ROOTS_DASHBOARD, `/billing/${id}`),
  blog: path(ROOTS_DASHBOARD, '/blog'),
  blogDetail: (id) => path(ROOTS_DASHBOARD, `/blog/${id}`),
  support: path(ROOTS_DASHBOARD, '/support'),
  contactus: path(ROOTS_DASHBOARD, '/contactus'),
  download: path(ROOTS_DASHBOARD, '/download'),
  recommended: path(ROOTS_DASHBOARD, '/recommended'),
  gettingStarted: path(ROOTS_DASHBOARD, '/getting-started'),
  virtualEstimator: path(ROOTS_DASHBOARD, '/virtual-estimator'),
  virtualEstimatorLeads: path(ROOTS_DASHBOARD, '/virtual-estimator/leads'),
  virtualEstimatorLeadDetail: (id) => path(ROOTS_DASHBOARD, `/virtual-estimator/leads/${id}`),
  pricingBom: path(ROOTS_DASHBOARD, '/pricing-bom'),
  pricingBomProjects: path(ROOTS_DASHBOARD, '/pricing-bom/projects'),
  pricingBomQuotes: path(ROOTS_DASHBOARD, '/pricing-bom/quotes'),
  pricingBomMaterials: path(ROOTS_DASHBOARD, '/pricing-bom/materials'),
  pricingBomBranding: path(ROOTS_DASHBOARD, '/pricing-bom/branding'),
  pricingBomQuoteDetail: (id) => path(ROOTS_DASHBOARD, `/pricing-bom/quotes/${id}`),
  pricingBomFenceDetail: (fenceId) => path(ROOTS_DASHBOARD, `/pricing-bom/fence/${fenceId}`),
  // congratulations pages
  planupdatesuccess: path(ROOTS_DASHBOARD, '/account/planupdate/success'),
  switchbillingsuccess: path(ROOTS_DASHBOARD, '/account/switchbilling/success'),
  paymentmethodupdatesuccess: path(ROOTS_DASHBOARD, '/account/updatepaymentmethod/success'),
  pausesubscriptionsuccess: path(ROOTS_DASHBOARD, '/account/pausesubscription/success'),
  cancelsubscriptionsuccess: path(ROOTS_DASHBOARD, '/account/cancelsubscription/success'),
  resumesubscriptionsuccess: path(ROOTS_DASHBOARD, '/account/resumesubscription/success'),
  // Legacy route groups kept for compatibility with older slices/layouts.
  general: {
    blog: {
      list: path(ROOTS_DASHBOARD, '/blog'),
    },
    subscription: {
      list: path(ROOTS_DASHBOARD, '/account'),
    },
    media: {
      root: path(ROOTS_DASHBOARD, '/account'),
    },
    fileManager: path(ROOTS_DASHBOARD, '/account'),
  },
  invoice: {
    root: path(ROOTS_DASHBOARD, '/billing'),
  },
  user: {
    profile: path(ROOTS_DASHBOARD, '/account'),
    cards: path(ROOTS_DASHBOARD, '/account'),
    list: path(ROOTS_DASHBOARD, '/account'),
    new: path(ROOTS_DASHBOARD, '/account'),
    a: path(ROOTS_DASHBOARD, '/account'),
    b: path(ROOTS_DASHBOARD, '/account'),
    c: path(ROOTS_DASHBOARD, '/account'),
    d: path(ROOTS_DASHBOARD, '/account'),
  },
  eCommerce: {
    list: path(ROOTS_MANAGEFENCE, '/featured'),
    category: path(ROOTS_MANAGEFENCE, '/featured'),
  },
};
export const PATH_ONBOARDING = {
  welcome: path(ROOTS_ONBOARDING, '/welcome'),
  fencelist: path(ROOTS_ONBOARDING, '/fence'),
  fenceDetail: (id) => path(ROOTS_ONBOARDING, `/fence/${id}`),
  download: path(ROOTS_ONBOARDING, '/download'),
  // Legacy alias used by older onboarding/managefence navigation files.
  onboarding: {
    fencelist: path(ROOTS_ONBOARDING, '/fence'),
    stylefences: path(ROOTS_ONBOARDING, '/fence'),
    viewDetail: (id) => path(ROOTS_ONBOARDING, `/fence/${id}`),
  },
};
export const PATH_MANAGEFENCE = {
  featured: path(ROOTS_MANAGEFENCE, '/featured'),
  addFence: path(ROOTS_MANAGEFENCE, '/add'),
  requestFence: path(ROOTS_MANAGEFENCE, '/request'),
  removeFence: path(ROOTS_MANAGEFENCE, '/remove'),
  viewFence: (id) => path(ROOTS_MANAGEFENCE, `/view/${id}`),
};
